// extracted by mini-css-extract-plugin
module.exports = {"answerContainer":"sequence-test_answerContainer__3QF7c","textAnswerContainer":"sequence-test_textAnswerContainer__2KG5l"};